import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Col, Modal, Row} from "react-bootstrap";
import {word} from "../../word.js";
import BlueButton from "../BlueButton/BlueButton.js";
import Loader from "../BlueButton/Loader.js";
import CheckboxFilter from "../CheckboxFilter.js";
import CustomDropdown from "./CustomDropdown.js";
import {Autocomplete, TextField} from "@mui/material";
import Api from "../../Api.js";
import {REACT_APP_API_URL} from "../../config.js";
import {withStyles,} from '@mui/styles';
import SuccessToast from "../BlueButton/SuccessToast.js";
import ErrorToast from "../BlueButton/ErrorToast.js";
import moment from "moment";

const ValidationTextField = withStyles({
    root: {
        '& input:valid + fieldset': {
            borderColor: '#63c0ba',
            borderWidth: 2,
        },
        '& input:invalid + fieldset': {
            borderColor: 'red',
            borderWidth: 2,
        },
        '& input:valid:focus + fieldset': {
            borderColor: '#63c0ba',
            borderLeftWidth: 6,
            padding: '4px !important', // override inline-style
        },
    },
})(TextField);

function AddRepeatedTask({show, onHide}) {
    const dispatch = useDispatch();
    const login = useSelector((state) => state.manager.employee);
    const account = useSelector((state) => state.task.accountant);
    const companies = useSelector((state) => state.task.companies);
    const managers = useSelector((state) => state.task.managers);
    const [limitData, setLimitData] = useState({
        organization: [],
        taskTemplate: [],
        manager: [],
        stuff: [],
    });
    const [template, setTemplate] = useState(true);

    useEffect(() => {
        (async () => {
            const {data} = await Api.taskTemplate()
            setTemplate(data)

        })();
    }, []);
    const [visibleForClient, setVisibleForClient] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [submitted, aetSubmitted] = useState(false);
    const [form, setForm] = useState([
        {key: "name", value: "", errorMessage: "empty_error", type: "text"},
        {key: "text", value: "", errorMessage: "empty_error", type: "text"},
        // { key: "duration", value: "", errorMessage: "empty_error", type: "number" },
        {
            key: "repeated_type",
            value: "",
            errorMessage: "empty_error",
            type: "dropDown",
            option: [
                {name: "daily", value: 1},
                {name: "weekly", value: 2},
                {name: "monthly", value: 3},
                {name: "annual", value: 4},
            ],
        },
        {
            key: "repeated_value",
            value: "",
            errorMessage: "respective_error",
            type: "number",
        },
        {
            key: "company",
            value: "",
            option: "organization",
            errorMessage: "select_error",
            type: "dropDown",
        },
        {
            key: localStorage.getItem("profession") !== "accountant" ? "accountant" : "manager",
            value: "",
            option: localStorage.getItem("profession") !== "accountant" ? "stuff" : "manager",
            errorMessage: "select_error",
            type: "dropDown",
        },
    ]);
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        (async () => {
            setLimitData({
                organization: companies.map(s => ({...s, url: REACT_APP_API_URL + 'manager-company/' + s.id + '/'})),
                taskTemplate: template.results,
                manager: managers,
                stuff: account.map(s => ({
                    value: s.id,
                    url: REACT_APP_API_URL + 'accountant/' + s.id + '/', ...s,
                    label: s.user.first_name + ' ' + s.user.last_name
                }))
            })
        })()
    }, [companies, managers, account, template])

    const getRepeatedType = () => {
        const repeatedTypeItem = form.find((f) => f.key === "repeated_type");
        return parseInt(repeatedTypeItem?.value || 0, 10);
    };

    const setIntervalCheck = (min, max, val) => {
        const num = parseInt(val, 10);
        return num >= min && num <= max;
    };

    const onChange = (e, item, index) => {
        const updatedForm = [...form];
        let value = e.target.value;
        updatedForm[index].value = value;

        if (item.key === "repeated_value" && getRepeatedType() === 4) {
            value = moment(value).dayOfYear()
            updatedForm[index].value = value;
        }


        let valid = false;
        switch (item.type) {
            case "number":
                const type = getRepeatedType();
                if (item.key === "duration") valid = value > 0 && value.length < 4;
                else if (type === 2) valid = setIntervalCheck(1, 7, value);
                else if (type === 3) valid = setIntervalCheck(1, 31, value);
                else if (type === 4) valid = setIntervalCheck(1, 366, value);
                break;
            case "text":
                valid = value.length > 0;
                break;
            default:
                break;
        }
        updatedForm[index].valid = valid;
        aetSubmitted(false);
        setForm(updatedForm);
    };
    const handleTemplateChange = (e, value) => {
        const updatedForm = form.map(item => {
            if (item.key === "name") {
                return {
                    ...item,
                    value: value ? value.name : "",
                    valid: true
                };
            }
            return item;
        });
        setForm(updatedForm);
    };
    const submit = async () => {
        try {
            const url = login.url;
            const profession = localStorage.getItem("profession");
            const creator = login.user.url;
            const formData = new FormData();

            setDisabled(true);

            for (const element of form) {
                if (!element.valid) {
                    setDisabled(false);
                    aetSubmitted(true);

                    return;
                }
                formData.append(element.key, element.value);
            }

            formData.append(profession, url);
            formData.append("creator", creator);
            formData.append("is_active", true);
            formData.append("visible_for_client", visibleForClient);
            await Api.createRepeatedTask(formData)
            await onHide()
            SuccessToast()
        } catch (e) {
            ErrorToast()
        }
    };
    const keyPress = async (e) => {
        if (e.key === "Enter") {
            await submit()
        }
    };
    const renderInput = ({item, index,}) => {
        if (getRepeatedType() === 1 && item.key === "repeated_value") {
            return null;
        }

        const handleChange = (e) => {
            onChange(e, item, index);
        };

        const handleFocus = () => {
            const updatedForm = [...form];
            updatedForm[index].active = true;
            setForm(updatedForm);
        };

        const handleBlur = () => {
            const updatedForm = [...form];
            updatedForm[index].active = false;
            setForm(updatedForm);
        };

        if (index === 3 && getRepeatedType() === 4) {
            return (
                <div className={!item.valid && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                    <TextField
                        id="date"
                        label="Օր"
                        type="date"
                        onChange={handleChange}
                        variant="outlined"
                        InputProps={{
                            inputProps: {
                                min: moment(new Date()).format("YYYY-MM-DD"), // Set minimum date if needed
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    {!item.valid && submitted && (
                        <div className="validation valid-center">
                            {word[item.errorMessage]}
                        </div>
                    )}
                </div>
            )
        }

        return (
            <div
                key={index}
                className={!item.valid && submitted ? "input-validation input-validation-valid" : "input-validation"}
            >
                <TextField
                    name={item.key}
                    value={item.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    type={item.type}
                    label={word[item.key]}
                    multiline={true}
                    maxLength={20}
                    onKeyDown={keyPress}
                    variant="outlined"
                    error={!item.valid && submitted}
                    id={!item.valid && submitted ? "validation-outlined-input" : "outlined-helperText"}
                />
                {!item.valid && submitted && (
                    <div className="validation valid-center">
                        {word[item.errorMessage]}
                    </div>
                )}
            </div>
        );
    };

    const handleChangeDate = e => setEndDate(e.target.value);

    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>{word.new_recommendations}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            <div className="input-validation">
                                <Autocomplete
                                    loading={!(limitData.taskTemplate && limitData.taskTemplate.length > 0)}
                                    loadingText={
                                        <div className="auto-complete-loader">
                                            <Loader type="Oval" color="#101C2A" height={15} width={15}/>
                                        </div>
                                    }
                                    id="combo-box-demo"
                                    options={limitData.taskTemplate}
                                    onChange={handleTemplateChange}
                                    getOptionLabel={option => option.name}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Ընտրել առաջադրանքի վերնագիր"
                                            variant="outlined"
                                            fullWidth
                                            onKeyDown={keyPress}
                                        />
                                    )}
                                />
                            </div>

                            {form.map((item, index) => {
                                if (item.type === "dropDown") {
                                    return (
                                        <CustomDropdown
                                            key={index}
                                            item={item}
                                            index={index}
                                            form={form}
                                            setForm={setForm}
                                            submitted={submitted}
                                            keyPress={keyPress}
                                            word={word}
                                            options={limitData} // or full props set
                                        />
                                    );
                                }
                                return (
                                    <div key={index}>{
                                        renderInput({item, index})
                                    }</div>
                                );
                            })}

                            <CheckboxFilter
                                title="Տեսանելի բոլորի համար"
                                my_task={visibleForClient}
                                onChange={() => setVisibleForClient(!visibleForClient)}
                            />

                            <div className='line-blue'/>

                            {disabled && (
                                <div className="disable-loader">
                                    <Loader size={30}/>
                                </div>
                            )}

                            <div className='button-line'>
                                <BlueButton
                                    disabled={disabled}
                                    buttonStyle={!disabled ? "blue-button" : "blue-button blue-button-disabled"}
                                    title={word.create}
                                    onChangeValue={submit}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AddRepeatedTask;